export const PHIN_GREETING = 'Phin here to help!';
